import { jsxs as p, jsx as i, Fragment as B } from "react/jsx-runtime";
import { useMemo as $, useId as M } from "react";
import { c as d } from "../clsx-OuTLNxxd.js";
import { L as I } from "../Label-B9Ttm_DE.js";
import '../PerformanceIndicator.css';const v = "320px", O = "600px", k = "1025px", A = "_performanceIndicator_wd1nl_32", L = "_container_wd1nl_36", j = "_percentage_wd1nl_48", F = "_label_wd1nl_56", P = "_indicatorWrapper_wd1nl_63", R = "_hasMaxWidth_wd1nl_71", C = "_indicator_wd1nl_63", D = "_success_wd1nl_82", E = "_failure_wd1nl_86", G = "_neutral_wd1nl_90", U = "_dateTop_wd1nl_94", Y = "_dateBottom_wd1nl_95", q = "_teamName_wd1nl_111", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: v,
  "mobile-wide": "480px",
  tablet: O,
  "tablet-wide": "800px",
  desktop: k,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  performanceIndicator: A,
  container: L,
  "spacing-s": "_spacing-s_wd1nl_42",
  "spacing-m": "_spacing-m_wd1nl_45",
  percentage: j,
  label: F,
  indicatorWrapper: P,
  hasMaxWidth: R,
  indicator: C,
  success: D,
  failure: E,
  neutral: G,
  dateTop: U,
  dateBottom: Y,
  teamName: q
}, b = (a) => {
  switch (a) {
    case "WON":
      return t.success;
    case "LOST":
      return t.failure;
    default:
      return t.neutral;
  }
}, H = ({ children: a, className: x, count: c, label: n, position: m, spacing: o }) => {
  const l = M();
  return /* @__PURE__ */ p("div", { className: d(t.performanceIndicator, x), "data-cxy-name": "performance-indicator", children: [
    n && /* @__PURE__ */ i(I, { className: t.label, htmlFor: l, children: n }),
    /* @__PURE__ */ i(
      "div",
      {
        "aria-label": "Performance Indicator",
        className: d(t.container, t[`spacing-${o}`]),
        id: l,
        role: "group",
        style: {
          "--indicator-count": c,
          justifyContent: m === "start" ? "flex-end" : "flex-start"
        },
        children: a
      }
    )
  ] });
}, X = ({
  americanFormat: a = !1,
  awayText: x = "A",
  className: c,
  formatDate: n,
  hasMaxWidth: m = !0,
  history: o,
  hitRate: l,
  homeText: y = "H",
  label: w,
  limit: h,
  position: S = "end",
  showHitRate: N = !0,
  showMatchInformation: u = !1,
  spacing: z = "m"
}) => {
  const T = $(
    () => [...o].sort((e, s) => new Date(s.startTime).getTime() - new Date(e.startTime).getTime()).slice(0, h),
    [o, h]
  ), _ = (e) => {
    const s = new Date(e), g = s.getMonth() + 1, r = s.getDate();
    return a ? `${g}/${r}` : `${r}/${g}`;
  }, W = (e, { showFullName: s } = {}) => {
    const g = e.participant.side === "AWAY", r = g ? e.homeTeam : e.awayTeam, f = s ? r.name : r.shortName;
    return a ? g ? `@${f}` : f || r.name : e.participant.side === "HOME" ? `${f} (${y})` : `${f} (${x})`;
  };
  return o.length ? /* @__PURE__ */ p(H, { className: c, count: o.length, label: w, position: S, spacing: z, children: [
    N && /* @__PURE__ */ p("span", { className: t.percentage, "data-testid": "hit-rate", children: [
      l,
      "%"
    ] }),
    T.map((e, s) => /* @__PURE__ */ p(
      "div",
      {
        className: d(t.indicatorWrapper, {
          [t.hasMaxWidth]: m
        }),
        "data-testid": "indicator",
        children: [
          u && /* @__PURE__ */ i("span", { className: t.dateTop, "data-testid": "date-top", children: n ? n(e.startTime, "M/d") : _(e.startTime) }),
          /* @__PURE__ */ i(
            "div",
            {
              "aria-label": `${e.participant.betResult === "WON" ? "Success" : e.participant.betResult === "LOST" ? "Failure" : "Undetermined"} against ${W(e)}`,
              className: d(t.indicator, b(e.participant.betResult)),
              role: "img"
            }
          ),
          u && /* @__PURE__ */ p(B, { children: [
            /* @__PURE__ */ i("span", { className: t.teamName, children: W(e) }),
            /* @__PURE__ */ i("span", { className: t.dateBottom, "data-testid": "date-bottom", children: n ? n(e.startTime, "M/d") : _(e.startTime) })
          ] })
        ]
      },
      s
    ))
  ] }) : null;
}, Z = ({
  className: a,
  hasMaxWidth: x,
  history: c,
  label: n,
  position: m,
  spacing: o
}) => c.length ? /* @__PURE__ */ i(H, { className: a, count: c.length, label: n, position: m, spacing: o, children: c.map((l, y) => /* @__PURE__ */ i(
  "div",
  {
    className: d(t.indicatorWrapper, {
      [t.hasMaxWidth]: x
    }),
    "data-testid": "indicator",
    children: /* @__PURE__ */ i("div", { className: d(t.indicator, b(l)), role: "img" })
  },
  y
)) }) : null;
export {
  X as PerformanceIndicator,
  Z as TipsterPerformanceIndicator
};
